export default function FormGroupTitle({ children }) {
    return <h3 className="form-group-title">{children}</h3>
}
